import React, {Fragment} from "react";
import ModalBase from "../../../../../ui/modals/ModalBase"
import {Image} from "react-bootstrap";

import annFloresAvatar from "../../../../../../assets/img/demo/ann-flores-avatar@2x.png";
import '../../../../../../assets/sass/pages/full-profile/tabs/scouting-reports-tab/more-information-modal.scss';

/**
 * Download report modal.
 */
class MoreInformationModal extends ModalBase {
    /**
     * Renders modal content within the body of the modal.
     * @returns {React.ReactNode} The modal content.
     */
    renderBody = () => {

        const description = "Short bio if available Esse excepteur proident tempor anim laborum sint et eiusmod id elit consesde.Esse excepteur proident tempor anim laborum sint et eiusmod id elit consesde.Esse excepteur proident tempor anim laborum sint et eiusmod id elit consesde.";
        return (
            <Fragment>
                <Image className="avatar" src={annFloresAvatar} roundedCircle={true}/>
                <div className="name"> {"Ann Flores"} </div>
                <div className="team"> {"Scout | Real Madrid Football Club"} </div>
                <div className="description"> {description} </div>
                <div className="connection d-flex flex-column">
                    <div className="title"> {"Connection"} </div>
                    <div className="value"> {"Not Connected"} </div>
                </div>
                <div className="send-request"> Send Connection request</div>
            </Fragment>
        );
    };

    renderHeader = () => undefined;
    renderFooter = () => undefined;


    /**
     * Returns default size of modal.
     * @returns {string} The modal size.
     */
    defaultSize = () => "";

    modalClassname = () => "more-information-modal";
}

MoreInformationModal.Name = "MoreInformationModal";


export default MoreInformationModal;
